// Generated by CoffeeScript 1.12.7

/**
Retrieves the parent url if displayed in iframe

@method getIframeUrl
@return {Object}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/get_iframe_url',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.getIframeUrl = factory();
  }
})(this, function() {
  var getIframeUrl;
  return getIframeUrl = function() {
    if (parent !== window) {
      return document.referrer;
    } else {
      return null;
    }
  };
});

